export default __webpack_public_path__ + "static/media/gummies.28fd2495.png";